import React from 'react';
import './App.css';
import { AppErrorBoundary } from './AppErrorBoundary';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navbar } from '../components/Navbar/Navbar';
import Home from './home/Home';
import 'bootstrap/dist/css/bootstrap.min.css';
import { RecoilRoot } from 'recoil';
import { Loader } from '../components/Loader/Loader';
import ReferralHome from './referral_home/ReferralHome';
import NotFound from './not_found/NotFound';
import ConsentForm from './consent_form/ConsentForm';
import OptOut from './optout/OptOut';
import { ToastContainer } from 'react-toastify';

function AppContent() {
  const location = useLocation();

  // Hide Navbar for routes starting with /cf/
  const hideNavbar = /^\/cf\/[^/]+$/.test(location.pathname);

  // Determine which component to use for /:uniqueId
  const isOptOutHost =
    window.location.hostname === "optout.tcpatech.com" ||
    window.location.hostname === "engage.tcpatech.com";
  const UniqueIdComponent = isOptOutHost ? OptOut : Home;
  // const UniqueIdComponent = OptOut;

  return (
    <>
      <ToastContainer />
      {/* {!hideNavbar && <Navbar />} */}
      <Routes>
        <Route path="/" element={<NotFound />} />
        <Route path="/:uniqueId" element={<UniqueIdComponent />} />
        <Route path="/cf/:uniqueId" element={<ConsentForm />} />
        {/* <Route path="/op/:optoutRefNo" element={<OptOut />} /> */}
        {/* <Route path="/:uniqueId/referral" element={<ReferralHome />} /> */}
        <Route path="/page/not-found" element={<NotFound />} />
      </Routes>
      {/* {!hideNavbar && <Footer />} */}
    </>
  );
}
export function App() {

  return (
    <React.StrictMode>
      <RecoilRoot>
        <AppErrorBoundary>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </AppErrorBoundary>
        <Loader />
      </RecoilRoot>
    </React.StrictMode>
  );
}

